export const batchModalReducerKey = 'batchModalReducerKey';
export const batchModalSetBatchFileReducerType = 'batchModalSetBatchFileReducerType';
export const batchModalSetOverwriteOptionsReducerType = 'batchModalSetOverwriteOptionsReducerType';
export const batchModalSetCurrentStructureOptionsReducerType = 'batchModalSetCurrentStructureOptionsReducerType';

export const typeOfBatchModal = 'typeOfBatchModal';
